export default __webpack_public_path__ + "static/media/liquidity_provider_right_bg.d4406677.png";